var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.92473 0 0 4.92473 0 11C0 17.0747 4.92473 22 11 22C17.0747 22 22 17.0747 22 11C22 4.92473 17.0747 0 11 0ZM12.853 16.6678C11.5753 18.3785 9.99827 19.1399 9.4276 19.1399C8.85642 19.1399 8.61201 18.4067 8.99254 16.5859C9.40075 14.4925 9.94456 11.9646 10.2709 10.3345C10.3514 9.95397 10.2969 9.73642 10.1616 9.73642C9.86266 9.73642 9.3457 10.0358 8.69365 10.5514C8.69365 10.5514 8.61201 10.5252 8.61201 10.4709C8.55748 10.3071 8.66628 9.84573 8.72132 9.76409C9.80813 8.64957 11.466 7.5356 12.1446 7.5356C12.4985 7.5356 12.5791 8.18688 12.3084 9.43753C12.0372 10.906 11.0853 15.0095 10.9227 16.2865C10.8684 16.7766 10.9503 16.9928 11.1947 16.9928C11.5483 16.9928 12.0639 16.6396 12.853 15.7978C12.853 15.7978 12.9336 15.8246 12.9336 15.8796C12.9604 16.0153 12.9067 16.5322 12.853 16.6678ZM12.7161 4.95271C12.5254 5.06228 11.629 5.14284 11.4937 5.03486C11.2216 4.87158 11.0855 4.5998 11.0586 4.11022C11.0855 3.89271 11.1948 3.48528 11.3035 3.34886C11.5753 3.0782 12.1446 2.86009 12.6087 2.86009C12.9873 2.86009 13.2049 2.96884 13.2613 3.05022C13.3687 3.21325 13.4224 3.53955 13.3956 3.78391C13.3418 4.30087 13.0437 4.73597 12.7161 4.95271Z",
    fill: "#003032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewInfoIcon);
export default __webpack_public_path__ + "static/media/new-info-icon.348c2ea81084e99f8da4fcabfc5b85ee.svg";
export { ForwardRef as ReactComponent };